export const CHOOSE_DOCUMENT_TYPE = 'page/CHOOSE_DOCUMENT_TYPE';
